(function() {
  'use strict';

  var pushedSections = {};
  var pushedScrollDepths = {};
  var lastAddToCartAt = 0;
  var lastBeginCheckoutAt = 0;
  var pageGroup = getPageGroup();

  window.dataLayer = window.dataLayer || [];
  window.OdyssGA = window.OdyssGA || {};
  window.OdyssGA.pageGroup = pageGroup;
  window.OdyssGA.track = track;

  ready(function() {
    bindExplicitTracking();
    bindScrollDepth();
    bindSectionImpressions();
    bindNavigationClicks();
    bindFooterClicks();
    bindCtaClicks();
    bindNewsletter();
    bindBlog();
    bindSupport();
    bindCommerce();
    bindSearch();
    bindAccount();
    bindVideos();
    trackPageStateEvents();
  });

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  function track(eventName, params) {
    if (!window.OdyssConsent.analyticsAllowed) return;
    var eventParams = clean(assign({ page_group: pageGroup }, params || {}));
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: eventName,
      event_parameters: eventParams
    });
  }

  function bindExplicitTracking() {
    document.addEventListener('click', function(event) {
      var el = event.target.closest('[data-ga-event]');
      if (!el) return;
      event.odyssGaHandled = true;
      track(el.getAttribute('data-ga-event'), explicitParams(el));
      trackSecondaryEvents(el);
    }, true);

    document.addEventListener('submit', function(event) {
      if (event.submitter && event.submitter.closest('[data-ga-event]')) return;
      var el = event.target.closest('[data-ga-event]');
      if (!el) return;
      event.odyssGaHandled = true;
      track(el.getAttribute('data-ga-event'), explicitParams(el));
      trackSecondaryEvents(el);
    }, true);
  }

  function trackSecondaryEvents(el) {
    var eventNames = (el.getAttribute('data-ga-secondary-events') || '').split(',');
    if (!eventNames.length) return;
    eventNames.forEach(function(eventName) {
      eventName = eventName.trim();
      if (!eventName) return;
      track(eventName, explicitParams(el));
    });
  }

  function bindScrollDepth() {
    var marks = [10, 25, 50, 75, 90, 100];
    function check() {
      var doc = document.documentElement;
      var body = document.body;
      var scrollTop = window.pageYOffset || doc.scrollTop || body.scrollTop || 0;
      var scrollHeight = Math.max(body.scrollHeight, doc.scrollHeight, body.offsetHeight, doc.offsetHeight);
      var viewport = window.innerHeight || doc.clientHeight || 0;
      var maxScroll = Math.max(scrollHeight - viewport, 1);
      var percent = Math.min(100, Math.round((scrollTop / maxScroll) * 100));
      marks.forEach(function(mark) {
        if (percent >= mark && !pushedScrollDepths[mark]) {
          pushedScrollDepths[mark] = true;
          track('scroll', { percent_scrolled: mark });
        }
      });
    }
    window.addEventListener('scroll', throttle(check, 250), { passive: true });
    check();
  }

  function bindSectionImpressions() {
    var sections = Array.prototype.slice.call(document.querySelectorAll([
      '[data-section-type]',
      '.obh',
      '.odyss-about-hero',
      '.odyss-about-story',
      '.odyss-about-trust',
      '.odyss-about-discover',
      '.newsletter-section',
      '.odyss-klaviyo-section',
      '.odyss-blog-grid-section',
      '.odyss-support-manual',
      '.product-single__meta'
    ].join(',')));

    if (!sections.length) return;

    function send(el) {
      var meta = sectionMeta(el);
      var key = meta.module_name + ':' + meta.title + ':' + el.id;
      if (pushedSections[key]) return;
      pushedSections[key] = true;
      track('section_impression', meta);
    }

    if (!('IntersectionObserver' in window)) {
      sections.forEach(send);
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          send(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.35 });

    sections.forEach(function(el) { observer.observe(el); });
  }

  function bindNavigationClicks() {
    document.addEventListener('click', function(event) {
      if (event.odyssGaHandled || hasExplicitSubmitter(event)) return;
      var logo = event.target.closest('.header-item--logo a, .site-header__logo a');
      if (logo) {
        track('click_nav', {
          module_name: 'top navigation',
          button_name: 'logo'
        });
        return;
      }

      var headerCta = event.target.closest('.odyss-site-header-cta');
      if (headerCta) {
        track('click_cta', {
          module_name: 'top navigation cta',
          button_name: label(headerCta)
        });
        return;
      }

      var icon = event.target.closest('.site-nav__link--icon');
      if (icon) {
        track('click_function', {
          module_name: 'top function',
          button_name: functionName(icon)
        });
        return;
      }

      var navLink = event.target.closest('.site-header .site-nav__link, .site-header .site-nav__dropdown-link, .slide-nav a');
      if (navLink) {
        track('click_nav', {
          module_name: 'top navigation',
          first_nav: label(navLink)
        });
      }
    });
  }

  function bindFooterClicks() {
    document.addEventListener('click', function(event) {
      if (event.odyssGaHandled || hasExplicitSubmitter(event)) return;
      var footerLink = event.target.closest('footer a, .footer a, [data-section-type="footer"] a, .odyss-brand-footer-section a');
      if (!footerLink) return;

      var social = socialName(footerLink);
      if (social) {
        track('click_social', {
          module_name: 'footer',
          button_name: social
        });
        track('follow_us', { button_name: social });
        return;
      }

      track('click_footer', {
        module_name: 'footer',
        button_name: label(footerLink),
        first_nav: nearestHeading(footerLink)
      });
    });
  }

  function bindCtaClicks() {
    document.addEventListener('click', function(event) {
      if (event.odyssGaHandled || hasExplicitSubmitter(event)) return;
      var cta = event.target.closest([
        '.obh-cta',
        '.obp-btn',
        '.osu-submit',
        '.btn',
        '.element-button',
        'a[class*="cta"]',
        'button[class*="cta"]'
      ].join(','));
      if (!cta || cta.closest('form[action*="/cart"], footer, .footer, .site-header')) return;

      var text = label(cta);
      if (!text || /add to cart|preorder|checkout|subscribe|login|sign in|register|search/i.test(text)) return;

      track('click_cta', {
        module_name: moduleName(cta),
        button_name: text
      });
    });
  }

  function bindNewsletter() {
    document.addEventListener('submit', function(event) {
      if (event.odyssGaHandled || hasExplicitSubmitter(event)) return;
      var form = event.target;
      if (!isNewsletterForm(form)) return;

      track('click_subscribe', {
        module_name: moduleName(form) || 'newsletter',
        button_name: submitLabel(form) || 'subscribe'
      });
    }, true);

    document.addEventListener('newsletter:success', function() {
      track('subscribe_success', {
        module_name: 'newsletter',
        button_name: 'subscribe'
      });
    });

    if (/[?&]customer_posted=true/.test(window.location.search) || document.querySelector('.newsletter-form__message--success, .note--success, .form-success')) {
      track('subscribe_success', {
        module_name: 'newsletter',
        button_name: 'subscribe'
      });
    }
  }

  function bindBlog() {
    document.addEventListener('click', function(event) {
      if (event.odyssGaHandled || hasExplicitSubmitter(event)) return;
      var category = event.target.closest('.odyss-category-nav a, a[href*="/tagged/"]');
      if (category) {
        track('click_blog_category', {
          module_name: 'blog_category_nav',
          category: label(category)
        });
        return;
      }

      var article = event.target.closest('.odyss-article-card a, .odyss-featured-article__link, .article__grid-meta a, a[href*="/blogs/"]');
      if (article && !article.closest('footer, .site-header')) {
        track('click_article', {
          module_name: 'blog_article_list',
          title: articleTitle(article)
        });
      }
    });
  }

  function bindSupport() {
    document.addEventListener('click', function(event) {
      if (event.odyssGaHandled || hasExplicitSubmitter(event)) return;
      var faq = event.target.closest('.faq button, .collapsible-trigger, summary');
      if (faq && (pageGroup === 'support' || faq.closest('.faq, .odyss-support-manual'))) {
        track('click_faq', {
          module_name: 'faq',
          title: label(faq),
          button_name: 'faq_toggle'
        });
        return;
      }

      var support = event.target.closest('.odyss-support a, .odyss-support-manual a');
      if (support) {
        track('support', { button_name: label(support) });
      }
    });

    document.addEventListener('submit', function(event) {
      if (event.odyssGaHandled || hasExplicitSubmitter(event)) return;
      var form = event.target;
      if (!form.matches('form[action*="/contact"]')) return;
      if (isNewsletterForm(form)) return;

      track(pageGroup === 'support' ? 'submit_question' : 'contact_form_submit', {
        module_name: 'contact_form',
        button_name: submitLabel(form) || 'submit',
        category: form.querySelector('[name*="category" i], [name*="topic" i]') ? form.querySelector('[name*="category" i], [name*="topic" i]').value : undefined
      });
    }, true);
  }

  function bindCommerce() {
    if (pageGroup === 'product') {
      var product = productData(document);
      track('view_item', {
        module_name: 'product detail',
        product_name: product.product_name,
        category: product.category
      });
    }

    document.addEventListener('ajaxProduct:added', function(event) {
      if (Date.now() - lastAddToCartAt < 1500) return;
      var source = event.detail && event.detail.product ? event.detail.product : document;
      var product = productData(source);
      trackAddToCart(product);
    });

    document.addEventListener('submit', function(event) {
      if (event.odyssGaHandled) return;
      var form = event.target;
      if (form.matches('form[action*="/cart/add"]')) {
        var product = productData(form);
        product.button_name = submitLabel(form) || product.button_name;
        trackAddToCart(product);
      }

      if (form.matches('form[action*="/cart"]') && form.querySelector('[name="checkout"]')) {
        trackBeginCheckout({
          module_name: 'cart',
          product_name: productData(document).product_name,
          button_name: 'checkout'
        });
      }
    }, true);

    document.addEventListener('click', function(event) {
      if (event.odyssGaHandled) return;
      var checkout = event.target.closest('.shopify-payment-button button, [name="checkout"], .cart__checkout');
      if (checkout) {
        trackBeginCheckout({
          module_name: 'cart',
          product_name: productData(document).product_name,
          button_name: label(checkout) || 'checkout'
        });
      }
    });
  }

  function trackAddToCart(product) {
    lastAddToCartAt = Date.now();
    track('add_to_cart', {
      module_name: 'product detail',
      product_name: product.product_name,
      button_name: product.button_name || 'add_to_cart'
    });
  }

  function trackBeginCheckout(params) {
    if (Date.now() - lastBeginCheckoutAt < 1500) return;
    lastBeginCheckoutAt = Date.now();
    track('begin_checkout', params);
  }

  function bindSearch() {
    document.addEventListener('submit', function(event) {
      if (event.odyssGaHandled) return;
      var form = event.target;
      if (!form.matches('form[action*="/search"]')) return;
      var input = form.querySelector('[name="q"], input[type="search"]');
      track('search', { search_term: input ? input.value : undefined });
    }, true);
  }

  function bindAccount() {
    document.addEventListener('click', function(event) {
      if (event.odyssGaHandled) return;
      var login = event.target.closest('a[href*="/account/login"], button[name="login"], input[type="submit"][value*="Sign in" i]');
      if (login) {
        track('click_login', {
          method: 'email',
          button_name: label(login) || 'login'
        });
      }

      var signup = event.target.closest('a[href*="/account/register"], .osu-submit');
      if (signup) {
        track('sign_up_entry', {
          button_name: label(signup) || 'sign_up'
        });
      }
    });

    if (document.body.className.indexOf('template-customers-login') > -1 && /[?&]return_url=/.test(window.location.search)) {
      track('login', { method: 'email' });
    }
    if (document.querySelector('.template-customers-register .form-success')) {
      track('sign_up');
    }
  }

  function bindVideos() {
    document.addEventListener('play', function(event) {
      var video = event.target;
      if (video.tagName !== 'VIDEO' || video.dataset.odyssGaStarted) return;
      video.dataset.odyssGaStarted = '1';
      track('video_start', videoParams(video));
    }, true);

    document.addEventListener('ended', function(event) {
      var video = event.target;
      if (video.tagName !== 'VIDEO') return;
      track('video_complete', videoParams(video));
    }, true);
  }

  function trackPageStateEvents() {
    if (document.querySelector('.osu-success')) {
      track('sign_up');
    }
  }

  function getPageGroup() {
    var path = window.location.pathname.replace(/\/+$/, '') || '/';
    if (path === '/') return 'homepage';
    if (/^\/blogs(\/|$)/.test(path)) return 'blog';
    if (/^\/products(\/|$)/.test(path)) return 'product';
    if (/^\/collections(\/|$)/.test(path)) return 'product';
    if (/support|manual|help|faq/.test(path)) return 'support';
    if (/about|story/.test(path)) return 'about';
    if (/privacy|terms|cookie|data-sharing-opt-out|legal/.test(path)) return 'legal';
    if (/cart/.test(path)) return 'cart';
    if (/account/.test(path)) return 'account';
    return 'other';
  }

  function sectionMeta(el) {
    return {
      module_name: moduleName(el),
      title: sectionTitle(el)
    };
  }

  function moduleName(el) {
    var section = el.closest('[data-section-type]') || el;
    var type = section.getAttribute && section.getAttribute('data-section-type');
    if (type) return normalize(type);
    var className = section.className ? String(section.className) : '';
    if (/obh|hero/i.test(className)) return 'hero';
    if (/newsletter|klaviyo/i.test(className)) return 'newsletter';
    if (/blog/i.test(className)) return 'blog_article_list';
    if (/support/i.test(className)) return 'support';
    if (/product/i.test(className)) return 'product detail';
    if (/footer/i.test(className)) return 'footer';
    return 'content';
  }

  function sectionTitle(el) {
    var title = el.querySelector && el.querySelector('h1, h2, h3, .section-header__title, .obh-title');
    return title ? label(title) : moduleName(el);
  }

  function productData(root) {
    var form = root.closest && root.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"], .product-single__form');
    var holder = form || document;
    var productNameNode = holder.querySelector && holder.querySelector('[data-product-title]');
    var productTypeNode = holder.querySelector && holder.querySelector('[data-product-type]');
    var productName = holder.getAttribute && holder.getAttribute('data-product-title') || productNameNode && (productNameNode.value || productNameNode.textContent);
    var category = holder.getAttribute && holder.getAttribute('data-product-type') || productTypeNode && (productTypeNode.value || productTypeNode.textContent);
    var button = form && form.querySelector('[data-add-to-cart-text], [data-add-to-cart], button[type="submit"]');

    return {
      product_name: normalize(productName || text('.product-single__title, [data-product-title], h1') || 'product'),
      category: normalize(category || text('[data-product-type]') || 'product'),
      button_name: button ? label(button) : undefined
    };
  }

  function videoParams(video) {
    return {
      video_title: video.getAttribute('title') || video.getAttribute('aria-label') || video.currentSrc.split('/').pop(),
      video_url: video.currentSrc || video.src
    };
  }

  function explicitParams(el) {
    return {
      page_group: el.getAttribute('data-ga-page-group') || pageGroup,
      module_name: el.getAttribute('data-ga-module'),
      button_name: el.getAttribute('data-ga-button') || label(el),
      title: el.getAttribute('data-ga-title'),
      first_nav: el.getAttribute('data-ga-first-nav'),
      second_nav: el.getAttribute('data-ga-second-nav'),
      third_nav: el.getAttribute('data-ga-third-nav'),
      category: el.getAttribute('data-ga-category'),
      product_name: el.getAttribute('data-ga-product-name'),
      search_term: el.getAttribute('data-ga-search-term'),
      method: el.getAttribute('data-ga-method')
    };
  }

  function hasExplicitSubmitter(event) {
    return !!(event.submitter && event.submitter.closest && event.submitter.closest('[data-ga-event]'));
  }

  function isNewsletterForm(form) {
    if (!form) return false;
    var textValue = (form.className + ' ' + form.id + ' ' + form.getAttribute('action')).toLowerCase();
    return /newsletter|klaviyo|contact#contact_form|customer_posted/.test(textValue) && !!form.querySelector('input[type="email"]');
  }

  function functionName(el) {
    var href = el.getAttribute('href') || '';
    if (/search/.test(href) || el.className.indexOf('search') > -1) return 'search';
    if (/cart/.test(href) || el.className.indexOf('cart') > -1) return 'cart';
    if (/account/.test(href) || el.className.indexOf('account') > -1) return 'account_login';
    return label(el);
  }

  function socialName(el) {
    var value = ((el.href || '') + ' ' + (el.className || '') + ' ' + label(el)).toLowerCase();
    var names = ['instagram', 'twitter', 'x', 'youtube', 'linkedin', 'facebook', 'tiktok', 'pinterest', 'discord', 'wechat', 'whatsapp'];
    for (var i = 0; i < names.length; i++) {
      if (value.indexOf(names[i]) > -1) return names[i] === 'twitter' ? 'x_twitter' : names[i];
    }
    return '';
  }

  function nearestHeading(el) {
    var parent = el.closest('ul, .footer__block, .footer__item, .footer__collapsible, .odyss-brand-footer');
    if (!parent) return undefined;
    var heading = parent.querySelector('h2, h3, .h4, .footer__title, summary');
    return heading ? label(heading) : undefined;
  }

  function articleTitle(el) {
    var article = el.closest('article, .odyss-article-card, .odyss-featured-article, li');
    var title = article && article.querySelector('h2, h3, .odyss-article-card__title, .odyss-featured-article__title');
    return title ? label(title) : label(el);
  }

  function submitLabel(form) {
    var button = form.querySelector('[type="submit"], button:not([type]), .btn');
    return button ? label(button) : undefined;
  }

  function label(el) {
    if (!el) return '';
    var value = el.getAttribute('data-ga-label') || el.getAttribute('aria-label') || el.getAttribute('title') || el.textContent || el.value || '';
    return normalize(value);
  }

  function text(selector) {
    var el = document.querySelector(selector);
    return el ? el.textContent : '';
  }

  function normalize(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '');
  }

  function clean(object) {
    Object.keys(object).forEach(function(key) {
      if (object[key] === undefined || object[key] === null || object[key] === '') {
        delete object[key];
      }
    });
    return object;
  }

  function assign(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] || {};
      Object.keys(source).forEach(function(key) {
        target[key] = source[key];
      });
    }
    return target;
  }

  function throttle(callback, delay) {
    var waiting = false;
    return function() {
      if (waiting) return;
      waiting = true;
      window.setTimeout(function() {
        waiting = false;
        callback();
      }, delay);
    };
  }
})();
